import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { BTInputPage } from '../bt/bt-input/bt-input';
import { MeasureInputPage } from '../measure-input/measure-input';
import { SummaryPage } from '../summary/summary';
import { BtLocalService } from '../../app/core/local-data-services/bt-local.service';
import { TabsService } from '../../app/core/tabs.service';
import {ThemeProvider} from "../../providers/theme/theme";

@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html'
})
export class TabsPage implements OnInit {
  tab1Root: any = BTInputPage;
  tab2Root: any = SummaryPage;

  tab1Title: string = " ";
  tab2Title: string = " ";

  tab1Url: string = '';
  tab2Url: string = 'summary-tab';

  constructor(private tabsService: TabsService,
              private translateService: TranslateService,
              private themeProvider: ThemeProvider) {

    translateService.get('TAB2_TITLE').subscribe(
      tab2Title => this.tab2Title = tab2Title
    );
  }

  ngOnInit(): void {
    this.setFirstTabRoot();

    this.tabsService.tab1Updated$.subscribe(
      () => this.setFirstTabRoot()
    );
  }

  private setFirstTabRoot(): void {
    if(BtLocalService.getBT() === null) {
      this.tab1Root = BTInputPage;
      this.tab1Url = 'bt-tab';
      this.tabsService.getTab1RootTitle().subscribe(
        tab1Title => this.tab1Title = tab1Title
      );
    } else {
      this.tab1Root = MeasureInputPage;
      this.tab1Url = 'measure-tab';
      this.tabsService.getTab1AltTitle().subscribe(
        tab1Title => this.tab1Title = tab1Title
      );
    }
  }

  changerTheme(){
    this.themeProvider.changerTheme();
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts